import logo from "./logo.svg";
import "./App.css";

function App() {
  return (
    <div>
      <h1>Welcome to Mammimia Page</h1>
    </div>
  );
}

export default App;
